import { forwardRef, ReactElement, RefObject, useState } from 'react';
import { DividerProps, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Box, Drawer, DrawerProps, List, Paper } from '@mui/material';
import ExpandableMenuItem from '@/layouts/ManagerLayout/ExpandableMenuItem';
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { useSpaceUserV2Store } from '@/store';

interface MenuItemBase {
    id?: string | number;
    label: string;
    icon?: ReactElement;
    to?: string;
    href?: string;
    target?: string;
    action?: () => void;
    isExistMatch?: boolean;
}

export interface MenuItem extends MenuItemBase {
    children?: MenuItemBase[] | ReactElement;
    isShowDivider?: boolean;
    DividerProps?: DividerProps;
    isActive?: boolean;
}

interface Props extends DrawerProps {
    isDrawerOpen?: boolean;
    appBarHeight?: number;
    menu?: MenuItem[];
    append?: ReactElement;
}

const MenuDrawer = (props: Props, ref: any) => {
    const { t } = useTranslation();
    const { isDrawerOpen = true, appBarHeight = 64, menu = [], append } = props;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { grade_name } = useSpaceUserV2Store();
    const isSodomall = grade_name === '소도몰';

    return (
        <Box>
            <Drawer
                PaperProps={{
                    ref: ref,
                    sx: {
                        minWidth: 240,
                        maxWidth: 320,
                        marginTop: `${appBarHeight}px`,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        '&::-webkit-scrollbar': {
                            // display:'none',
                            // backgroundColor: 'red',
                            // width: 30,
                        },
                    },
                }}
                variant={!isMobile ? 'persistent' : 'temporary'}
                open={isDrawerOpen}
                sx={{
                    flexShrink: 0,
                }}
            >
                <Paper elevation={0}>
                    <List
                        sx={{
                            '& .MuiListItemIcon-root': { minWidth: 35 },
                        }}
                    >
                        {menu.map((item, index) => {
                            return <ExpandableMenuItem {...item} key={item?.id || index} />;
                        })}
                    </List>
                    <List
                        sx={{
                            '& .MuiListItemIcon-root': { minWidth: 35 },
                        }}
                    >
                        <ExpandableMenuItem
                            label={t('product.customerCenter')}
                            target="_blank"
                            href="http://pf.kakao.com/_BxfaRn/chat"
                            // href='https://help.flowing.space/hc/ko/requests/new'
                            isShowDivider
                            icon={<SupportAgentIcon />}
                        />
                        {/* DDM Live 업데이트 - 소도몰 역할일 때 숨김 */}
                        {!isSodomall && (
                            <ExpandableMenuItem
                                label={t('product.ddmLiveUpdate')}
                                href="https://flowing.oopy.io/0a190ec2-b0b8-435d-9701-9488f8be7d0a"
                                // label="사용 가이드"
                                // href='https://flowing.oopy.io/guide/seller/profile-link'
                                target="_blank"
                                // isShowDivider
                                icon={<ArticleOutlinedIcon />}
                            />
                        )}
                    </List>
                </Paper>
                {!!append ? (
                    <div
                        style={{
                            paddingBottom: appBarHeight,
                        }}
                    >
                        {append}
                    </div>
                ) : (
                    ''
                )}
            </Drawer>
        </Box>
    );
};

export default forwardRef(MenuDrawer);
